import React from 'react';
import '../InstructionsPopup.css';

export default function ManualCapturePopup({ configValue, closeProcess, openCamera }) {
  // Usar los mismos colores del configValue que se usan en el fondo y mensajes de status
  const backgroundColor = configValue?.styles?.backgroundColor || '#1a1a1a';
  const messageColor = configValue?.styles?.messageColor || '#ffffff';
  const messageBackgroundColor = configValue?.styles?.messageBackgroundColor || '#333333';
  const guideColor = configValue?.styles?.guideColor || '#00bcd4';

  return (
    <div className="instructions-popup-overlay" style={{ backgroundColor: backgroundColor }}>
      <div className="instructions-popup" style={{ backgroundColor: messageBackgroundColor }}>
        <div className="instructions-header">
          <h2 style={{ color: messageColor }}>Prepara tu Documento</h2>
        </div>

        <div className="instructions-content">
            <p style={{ color: messageColor }}>
                Para validar tu identidad de forma segura, a continuación se abrirá la cámara de tu dispositivo.
            </p>
        </div>

        <div className="instructions-footer" style={{display: 'flex', gap: 10, justifyContent: 'space-between', alignItems: 'center'}}>
            <button
                className="instructions-close-button"
                style={{
                    backgroundColor: backgroundColor,
                    color: messageColor,
                    border: `2px solid ${messageColor}`
                }}
                onClick={closeProcess}
            >
                Salir
            </button>
            <button
            className="instructions-close-button"
            style={{
              backgroundColor: guideColor,
              color: messageBackgroundColor,
              border: `2px solid ${messageColor}`
            }}
            onClick={openCamera}
          >
              Abrir Cámara
          </button>
        </div>
      </div>
    </div>
  );
}
